export default "__VITE_ASSET__DvWbxx1L__"